import { render } from "./fp_notes.vue?vue&type=template&id=25a3b121&scoped=true"
import script from "./fp_notes.vue?vue&type=script&lang=js"
export * from "./fp_notes.vue?vue&type=script&lang=js"

import "./fp_notes.vue?vue&type=style&index=0&id=25a3b121&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25a3b121"]])

export default __exports__